<template>
  <v-form
      ref="form"
      :model="input"
      :action="endpoint"
      :method="method"
  >
    <template scope="{ error, errorState }">
      <div>
        <b-tabs>
          <b-tab title="User"
                 active>
            <v-input-field
                label="First Name"
                v-model="input.first_name"
                :error="error('first_name')"
                placeholder="Enter First Name"
                :state="errorState('first_name')"
            />
            <v-input-field
                label="Name"
                v-model="input.last_name"
                :error="error('last_name')"
                placeholder="Enter Last Name"
                :state="errorState('last_name')"
            />
            <v-input-field
                label="Email"
                type="email"
                description="example@domain.com"
                v-model="input.email"
                :error="error('email')"
                placeholder="Enter Email"
                :state="errorState('email')"
            />
          </b-tab>
          <b-tab title="Permissions">
            <v-checkbox
                description="Select the roles for the user."
                v-model="input.roles"
                :options="roleOptions"
                :error="error('roles')"
                :state="errorState('roles')"
            />
          </b-tab>
        </b-tabs>
      </div>

    </template>
  </v-form>
</template>

<script>
export default {
  props: {
    "roles": {
      default: []
    },
    "userRoles": {
      default: []
    },
    "user": {
      default: {}
    },
    "method": {
      default: "PUT"
    },
    "action": {}
  },
  data() {
    return {
      input: {
        first_name: '',
        last_name: '',
        email: '',
        roles: []
      },
      error: ""
    }
  },
  computed: {
    roleOptions() {
      return this.roles.map((role) => {
        return {
          text: role,
          value: role
        }
      })
    },
    endpoint() {
      if (this.action) {
        return this.action
      }
      return "/users/" + this.user.id
    }
  },
  created() {
    this.input.first_name = this.user.first_name
    this.input.last_name = this.user.first_name
    this.input.email = this.user.email
    this.input.roles = this.userRoles
  }
}

</script>
